// Remplace la tranche d'âge saisie sur un animal (ageInterval) par une date de
// naissance (birthDate, 'YYYY-MM'), la tranche étant désormais calculée à partir de celle-ci.
// La date retenue est janvier de (année en cours - âge minimum de la tranche) : la tranche
// calculée aujourd'hui est donc celle qui avait été saisie.
// Les animaux déjà adaptés (birthDate ou ancienne birthYear présente) sont ignorés ;
// les années de naissance sont converties par le job adaptAnimalBirthDates.

async function applyJob() {
    const animalCollection = global.app.C.Animal.collection
    const ageIntervalCollection = global.app.C.AgeInterval.collection

    const animals = await animalCollection.find({birthDate: {$exists: false}, birthYear: {$exists: false}}).toArray()
    if (!animals.length) return {message: "Aucun animal à adapter"}

    const intervalIds = animals.map(animal => animal.ageInterval).filter(Boolean)
    const intervals = await ageIntervalCollection.find({_id: {$in: intervalIds}}).toArray()
    const minAgeById = new Map(intervals.map(interval => [interval._id.toString(), interval.minAge]))

    const currentYear = new Date().getFullYear()
    let withoutAge = 0
    const operations = animals.map(animal => {
        const minAge = animal.ageInterval && minAgeById.get(animal.ageInterval.toString())
        const hasMinAge = typeof minAge === 'number'
        if (!hasMinAge) withoutAge++
        return {
            updateOne: {
                filter: {_id: animal._id},
                update: {
                    $set: {birthDate: hasMinAge ? `${currentYear - minAge}-01` : null},
                    $unset: {ageInterval: ''}
                }
            }
        }
    })

    const result = await animalCollection.bulkWrite(operations)
    return {message: `${result.modifiedCount} animal(aux) adapté(s), dont ${withoutAge} sans tranche d'âge exploitable (date de naissance à saisir)`}
}

export const job = {
    name: "adaptAnimalBirthYears",
    title: "Adapter l'âge des animaux (année de naissance)",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
